import React from 'react';

export default function FirstVideo() {
  return (
    <div>
      <div className="wistia_responsive_padding">
        <div className="wistia_responsive_wrapper">
          <iframe
            src="https://www.youtube.com/embed/y-QJ5TUuuRk"
            title="Virtual Services TEST Video"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            allowFullScreen
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  );
}
